import { ModalName } from 'features/modal/types';
import { getAPIDomain } from './http';
import { safeLocalStorage } from './storage';

type PreferenceOptions = {
  global?: boolean;
  prefix?: string;
};

const getDontShowAgainPrefix = (modalName: ModalName | string, options?: PreferenceOptions) => {
  if (options?.global) {
    return `dontShowAgain_${modalName}`;
  }

  return `${options?.prefix ?? getAPIDomain()}_dontShowAgain_${modalName}`;
};

export const getDontShowAgainPreference = (
  modalName: ModalName | string,
  options?: PreferenceOptions
): boolean => {
  try {
    return safeLocalStorage.getItem(getDontShowAgainPrefix(modalName, options)) === 'true';
  } catch {
    return false;
  }
};

export const setDontShowAgainPreference = (
  modalName: ModalName | string,
  value: boolean,
  options?: PreferenceOptions
): void => {
  try {
    if (value) {
      safeLocalStorage.setItem(getDontShowAgainPrefix(modalName, options), 'true');
    }
  } catch {
    // do nothing
  }
};
